import { render, staticRenderFns } from "./kpis-widget.component.vue?vue&type=template&id=0c6a3a92&scoped=true"
import script from "./kpis-widget.component.vue?vue&type=script&lang=ts"
export * from "./kpis-widget.component.vue?vue&type=script&lang=ts"
import style0 from "./kpis-widget.component.vue?vue&type=style&index=0&id=0c6a3a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a3a92",
  null
  
)

export default component.exports